import { createEvent, createStore, restore } from 'effector'
import { forward } from 'effector/effector.umd'

import { SmartContractSingleCarState } from '../detail/types'
import { DealerShipToWidgetMap, WidgetIds } from '../types'

export const $state = createStore<null | SmartContractSingleCarState>(null)
export const setState = createEvent<SmartContractSingleCarState>()

export const $dealerships = createStore<DealerShipToWidgetMap | null>(null)
export const setDealerships = createEvent<DealerShipToWidgetMap>()

export const $replaceForms = createStore(false)
export const setReplaceForms = createEvent<boolean>()

export const setTradeInPrice = createEvent<number>()
export const $tradeInPrice = restore(setTradeInPrice, null)

export const setTradeInEnabled = createEvent<boolean>()
export const $tradeInEnabled = restore(setTradeInEnabled, null)

export const setTradeInState = createEvent()

forward({
  from: setTradeInState,
  to: []
})

export const widgetIDByDealerChanged = createEvent<Record<string, WidgetIds>>()
export const $widgetIDByDealer = restore(widgetIDByDealerChanged, null)

export const $loading = createStore<boolean>(false)
export const setLoading = createEvent<boolean>()
